import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'

export const FETCH_DIVISIONS_LIST = 'FETCH_DIVISIONS_LIST'
export const RECEIVE_DIVISIONS_LIST = 'RECEIVE_DIVISIONS_LIST'
export const FAILED_DIVISIONS_LIST = 'FAILED_DIVISIONS_LIST'

export function fetchDivisions(){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_DIVISIONS_LIST});
        axios({
            method: 'post',
            url: API_LINKS.DIVISION_LIST_URL,
            headers: {
                Authorization: auth
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_DIVISIONS_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_DIVISIONS_LIST
                    })
                    return toast.error("Invalid credentials! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_DIVISIONS_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_DIVISIONS_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_DIVISIONS_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_DIVISIONS_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_DIVISIONS_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}